import { apiClient } from "../lib/api-client";

/**
 * Upload an organization logo file to the storage service.
 * Returns the storage URL (/api/storage/{fileId}) to store in the logo field.
 */
export async function uploadOrgLogo(file: File, organizationId: string): Promise<string> {
  const formData = new FormData();
  formData.append("file", file);

  // Storage upload uses bare fetch because it needs multipart FormData
  const response = await fetch(`/api/storage/upload?organizationId=${encodeURIComponent(organizationId)}`, {
    method: "POST",
    body: formData,
    credentials: "include",
  });

  if (!response.ok) {
    const data = await response.json();
    throw new Error("error" in data ? (data.error as string) : "Failed to upload logo");
  }

  const result = (await response.json()) as { id: string };
  return `/api/storage/${result.id}`;
}

/**
 * Delete an organization logo and its storage file via the dedicated endpoint.
 * This clears the logo field in the DB and removes the file from storage.
 */
export async function deleteOrgLogo(organizationId: string): Promise<void> {
  const response = await apiClient.organizations[":id"].logo.$delete({
    param: { id: organizationId },
  });

  if (!response.ok) {
    const data = await response.json();
    throw new Error("error" in data ? (data.error as string) : "Failed to delete logo");
  }
}
